import { render, staticRenderFns } from "./documents.abb.vue?vue&type=template&id=afd6b9dc"
import script from "./documents.abb.vue?vue&type=script&lang=js"
export * from "./documents.abb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports